<template>
  <div>
    <YshTaskList :projectType="projectType"></YshTaskList>
  </div>
</template>
<script>
import { mapState } from "vuex";
import YshTaskList from "@/components/Task/TaskList";
export default {
  components: {
    YshTaskList
  },
  data () {
    return {

    };
  },
  computed: {
    ...mapState({
      projectType: state => state.homeProject.projectType,
    })
  }
};
</script>
